// src/features/stock/hooks/useStockMovement.js
import { useState, useCallback } from 'react';
import toast from 'react-hot-toast';
import stockApi from '../services/stockApi';

export const useStockMovement = () => {
  const [movements, setMovements] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
  });

  const fetchMovements = useCallback(async (params = {}) => {
    setLoading(true);
    try {
      const response = await stockApi.getStockMovements({
        page: pagination.currentPage,
        ...params,
      });
      setMovements(response.data.data);
      setPagination({
        currentPage: response.data.current_page,
        totalPages: response.data.last_page,
        totalItems: response.data.total,
      });
    } catch (err) {
      toast.error('Failed to fetch stock movements');
    } finally {
      setLoading(false);
    }
  }, [pagination.currentPage]);

  const createMovement = async (data) => {
    try {
      const response = await stockApi.createStockMovement(data);
      toast.success('Stock movement recorded successfully');
      fetchMovements();
      return response.data;
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to record movement');
      throw err;
    }
  };

  const getItemMovements = async (itemId, params = {}) => {
    setLoading(true);
    try {
      const response = await stockApi.getStockMovementsByItem(itemId, params);
      setMovements(response.data.data);
      return response.data;
    } catch (err) {
      toast.error('Failed to fetch item movements');
    } finally {
      setLoading(false);
    }
  };

  return {
    movements,
    loading,
    pagination,
    fetchMovements,
    createMovement,
    getItemMovements,
  };
};